<script setup lang="ts">
const props = defineProps<{
  modelValue: boolean
  label: string
  disabled?: boolean
}>()

const emit = defineEmits(['update:modelValue'])

const toggle = computed({
      get () {
        return props.modelValue
      },
      set (value) {
        emit('update:modelValue', value)
      }
    })
</script>

<template>
  <label>
    <input
      type="checkbox"
      :value="props.modelValue"
      :disabled="props.disabled"
      v-model="toggle"
      class="accent-black"
    />
    {{ props.label }}
  </label>
</template>
